import {Dimensions, StyleSheet} from 'react-native';
import {Colors} from '../../../../constants/Colors';

export const styles = StyleSheet.create({
  containerModal: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.4)',
    justifyContent: 'flex-end',
  },
  containerFilter: {
    height: Dimensions.get('window').height * 0.9,
    width: '95%',
    backgroundColor: 'white',
    alignSelf: 'center',
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    paddingVertical: 25,
  },
  spaceHorizontal: {
    paddingHorizontal: 25,
  },
  iconX: {
    alignSelf: 'flex-end',
  },
  filterTitle: {
    fontSize: 14,
    fontFamily: 'TCCC-UnityText Bold',
    lineHeight: 19,
    color: 'black',
    marginTop: 20,
    maxWidth: 300,
  },
  containerDrop: {
    marginTop: 30,
    paddingHorizontal: 25,
  },
  containerButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 45,
    marginTop: 50,
  },
  orderContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 10,
    marginTop: 20,
  },

  containerConfirmed: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 20,
  },
  filterButton: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 15,
  },
  filterText: {
    marginRight: 10,
    fontSize: 12,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 14,
    color: Colors.RedPallete.red,
  },
  orderText: {
    fontFamily: 'TCCC-UnityText Bold',
    fontSize: 14,
    fontWeight: '400',
    lineHeight: 19,
    color: Colors.GrayPallete.lightgrayThree,
  },
  codeText: {
    fontSize: 12,
    fontWeight: '400',
    lineHeight: 19,
    color: Colors.GrayPallete.lightGrayFour,
    fontFamily: 'TCCC-UnityText Regular',
  },
  orderInfo: {
    marginTop: 0,
    fontSize: 12,
    color: Colors.GrayPallete.lightgrayThree,
  },
  ProductsText: {
    fontSize: 12,
    fontWeight: '400',
    lineHeight: 19,
    color: 'black',
    marginTop: 20,
    fontFamily: 'TCCC-UnityText Regular',
  },
});
